import { render, staticRenderFns } from "./iamBstanRtsis.vue?vue&type=template&id=02521643&scoped=true&"
import script from "./iamBstanRtsis.vue?vue&type=script&lang=js&"
export * from "./iamBstanRtsis.vue?vue&type=script&lang=js&"
import style0 from "./iamBstanRtsis.vue?vue&type=style&index=0&id=02521643&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02521643",
  null
  
)

export default component.exports